import React, { Component } from "react";

import { Modal } from "reactstrap";

class modal extends Component {
  state = {
    modal: this.props.modal
  };

  componentWillReceiveProps(next) {
    // console.log("output: modal -> componentWillReceiveProps -> next", next);
    if (next.modal === "click") {
      this.setState(prevState => ({
        modal: !prevState.modal
      }));
    }
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  };

  render() {
    return (
      <Modal
        isOpen={this.state.modal}
        toggle={this.toggle}
        className={this.props.className}
      >
        <div className="modal-content">
          <div className="modal-body">
            <p>{this.props.text}</p>
          </div>
          <div className="modal-footer flex-center">
            <button
              type="button"
              className="btn btn-alert-secondary"
              data-dismiss="modal"
              onClick={this.toggle}
            >
              ตกลง
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
export default modal;
